module.exports = __webpack_public_path__ + "img/groenkaalsvampe.42c58322.jpg";